import { render } from "./UiAlert.vue?vue&type=template&id=95901208&scoped=true"
import script from "./UiAlert.vue?vue&type=script&lang=js"
export * from "./UiAlert.vue?vue&type=script&lang=js"

import "./UiAlert.vue?vue&type=style&index=0&id=95901208&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95901208"]])

export default __exports__